import Axios from 'axios';
import { ApiResultModel, IReferenceKey } from '../models/common.model';
import { APIBASE_URL, IDENTITY_URL } from '../config/cacheKey';
import {
    IDocumentRequest,
    IDocumentResponse,
    IGetDocumentsResponse,
    IRegisterDocumentRequest,
    IRemoveDocumentResponse,
} from '../models/identity.model';

export const GetDocumentByLoanRequest = (
    data: IReferenceKey
): Promise<IDocumentResponse[]> => {
    return Axios.post<ApiResultModel<IDocumentResponse[]>>(
        APIBASE_URL + IDENTITY_URL + '/GetDocumentsByLoanRequest',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const RegisterDocument = async (
    data: IRegisterDocumentRequest
): Promise<ApiResultModel<IDocumentResponse>> => {
    const formData = new FormData();
    if (data.referenceKey) {
        formData.append('referenceKey', data.referenceKey!.toString());
        formData.append('documentType', data.documentType!.toString());
        formData.append('base64Date', data.base64Date!.toString());
        formData.append('data', data.data!, data.data.name);
    }
    return Axios.post<ApiResultModel<IDocumentResponse>>(
        APIBASE_URL + IDENTITY_URL + '/RegisterDocument',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data; charset=utf-8',
            },
        }
    ).then((result) => {
        return result.data;
    });
};
export const RemoveDocument = (
    data: IDocumentRequest
): Promise<IRemoveDocumentResponse> => {
    return Axios.post<ApiResultModel<IRemoveDocumentResponse>>(
        APIBASE_URL + IDENTITY_URL + '/RemoveDocument',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetDocument = (
    data: IDocumentRequest
): Promise<ApiResultModel<IDocumentResponse>> => {
    return Axios.post<ApiResultModel<IDocumentResponse>>(
        APIBASE_URL + IDENTITY_URL + '/GetDocument',
        data
    ).then((result) => {
        return result.data;
    });
};

export const GetRequiredDocuments = (
    data: IReferenceKey
): Promise<IGetDocumentsResponse[]> => {
    return Axios.post<ApiResultModel<IGetDocumentsResponse[]>>(
        APIBASE_URL + IDENTITY_URL + '/GetRequiredDocuments',
        data
    ).then((result) => {
        return result.data.data;
    });
};
